













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

type typeAxType = 'link' | 'button';

@Component({
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('response', ['requestPath']),
  },
})
export default class LoginButton extends Vue {
  @Prop({ type: String, default: 'clicked_login_from_header' }) private readonly axId?: string;
  @Prop({ type: String, default: 'button' }) private readonly axType?: typeAxType;
  @Prop({ type: String, default: 'Log in' }) private readonly text!: string;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  private readonly axExtra?: object;
}
